module.exports = __webpack_public_path__ + "static/media/TUR.121e8386.svg";